import { Calendar } from '@powerportalspro/react-calendar';
import { ColumnEdit } from '@powerportalspro/react-fluent';
import { ACCOUNT_ID } from '../demos/DetailPageRecords';

// Schmeler and Sons' appointments, each opening on fields of the page's choosing.
const account = { tableName: 'account', id: ACCOUNT_ID };

export function CalendarDetailsSample() {
  return (
    <Calendar
      regarding={account}
      defaultLayout="month"
      defaultTables={['appointment']}
      height="560px"
      appointmentDetails={
        <>
          <ColumnEdit columnName="scheduledstart" readOnly />
          <ColumnEdit columnName="scheduledend" readOnly />
          <ColumnEdit columnName="location" readOnly />
          <ColumnEdit columnName="requiredattendees" readOnly />
        </>
      }
    />
  );
}
